// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"143":"54016fa3","186":"8a2770ee","239":"59dfe217","388":"ba62e248","588":"da0ab783","788":"8aaff232","960":"6f636788"}[chunkId] + ".css";
};